import React, { useEffect } from 'react';

export default function TallyWrapper({formURL, formTitle}){
	// The code below will load the embed
	useEffect(() => {
    if (typeof window === 'undefined') return

    const widgetScript = 'https://tally.so/widgets/embed.js'

    const loadEmbeds = () => {
      if (window.Tally) {
        window.Tally.loadEmbeds()
        return
      }
      // fallback for iframes without src set yet
      document
        .querySelectorAll('iframe[data-tally-src]:not([src])')
        .forEach(el => { el.src = el.dataset.tallySrc })
    }

    // if the script’s already loaded, just run it
    if (window.Tally) {
      loadEmbeds()
    } else if (!document.querySelector(`script[src="${widgetScript}"]`)) {
      // otherwise inject the script once
      const script = document.createElement('script')
      script.src = widgetScript
      script.async = true
      script.onload = loadEmbeds
      script.onerror = loadEmbeds
      document.body.appendChild(script)
    }
  }, []
  )
  
  return (
    <div>
		<iframe
            data-tally-src={`${formURL}`}
            loading="lazy"
            width="100%"
            height="216"
            frameBorder={0}
            marginHeight={0}
            marginWidth={0}
            title={`${formTitle}`}
        >
        </iframe>
	</div>
  );
};